import Vue from 'vue'
import './configuration'
import './components'

const runApp = () => {
  if (document.getElementById('header')) {
    // Run app in site mode
    new Vue({
      el: 'main'
    })
  } else {
    // Run app in dev-server mode
    ;(async function() {
      const App = (await import('./app')).default

      new Vue({
        el: 'main',
        render: h => h(App)
      })
    })()
  }
}

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
  runApp()
} else {
  document.addEventListener('DOMContentLoaded', runApp)
}
